import React, { useState, useEffect } from 'react';

const HeroSlider: React.FC = () => {
  const [slideIndex, setSlideIndex] = useState(0);
  const totalSlides = 3;

  useEffect(() => {
    const interval = setInterval(() => {
      setSlideIndex((prev) => (prev + 1) % totalSlides);
    }, 5000);
    return () => clearInterval(interval);
  }, [totalSlides]);

  const moveSlide = (n: number) => {
    setSlideIndex((prev) => {
      let next = prev + n;
      if (next >= totalSlides) return 0;
      if (next < 0) return totalSlides - 1;
      return next;
    });
  };

  return (
    <div className="hero-slider-container bg-[#1f232e] text-white rounded-[20px] shadow-lg relative mb-8 border border-gray-800 overflow-hidden">
      <div
        className="hero-slides flex transition-transform duration-500 ease-in-out"
        style={{
          width: '300%',
          transform: `translateX(-${slideIndex * (100 / totalSlides)}%)`,
        }}
      >
        {/* Slide 1 */}
        <div className="hero-slide w-1/3 flex-shrink-0 flex flex-col md:flex-row items-center justify-between !p-8 md:!p-12 md:!px-16 relative min-h-[350px]">
          <div className="w-full md:w-1/2 z-10 text-white">
            <h1 className="text-3xl md:text-5xl font-bold mb-4 tracking-tight leading-tight !text-white">
              Khi họ giao dịch, <br />
              bạn cũng giao dịch
            </h1>
            <p className="text-gray-300 text-sm md:text-base mb-8 max-w-md leading-relaxed">
              Sử dụng CopyTrader để tự động sao chép chiến lược của những nhà giao dịch hàng đầu. Tìm kiếm những chuyên gia phù hợp với mục tiêu của bạn và đa dạng hóa danh mục chỉ với một cú nhấp chuột.
            </p>
          </div>
          <div className="w-full md:w-1/2 flex justify-center mt-6 md:mt-0 relative z-10 h-full items-center">
            <div className="relative w-full max-w-[360px] md:max-w-[400px] h-[250px]">
              <div className="absolute right-4 md:right-8 top-0 bg-[#292e3a] p-4 rounded-xl shadow-2xl w-48 border border-gray-700 z-20 transform -rotate-2 transition-transform hover:rotate-0">
                <div className="w-full h-32 bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-700 rounded-lg mb-3 flex flex-col items-center justify-center text-white relative overflow-hidden">
                  <img
                    src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&auto=format&fit=crop&q=80"
                    alt="Mike More"
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      (e.currentTarget as HTMLElement).style.display = 'none';
                    }}
                  />
                  <div className="absolute inset-0 bg-black/20"></div>
                </div>
                <div className="font-semibold text-white">Mike More</div>
                <div className="text-green-400 font-bold text-lg">48.08%</div>
                <div className="text-gray-400 text-xs">Lợi nhuận (12T)</div>
              </div>
              <div className="absolute right-0 bottom-4 bg-[#292e3a] p-3 rounded-xl shadow-2xl border border-gray-700 z-30 transform translate-x-2 md:translate-x-4 translate-y-4">
                <div className="flex items-end space-x-1 h-16 w-24">
                  <div className="w-2 bg-green-500 h-8 rounded-sm"></div>
                  <div className="w-2 bg-green-500 h-12 rounded-sm"></div>
                  <div className="w-2 bg-red-500 h-6 rounded-sm"></div>
                  <div className="w-2 bg-green-500 h-14 rounded-sm"></div>
                  <div className="w-2 bg-red-500 h-10 rounded-sm"></div>
                  <div className="w-2 bg-green-500 h-16 rounded-sm"></div>
                </div>
              </div>
              <div className="absolute left-6 md:left-10 top-10 w-12 h-12 rounded-md overflow-hidden border-2 border-[#1f232e] shadow-lg bg-indigo-700 flex items-center justify-center text-xs font-bold text-white opacity-90">
                <img
                  src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&auto=format&fit=crop&q=80"
                  alt="User 1"
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    (e.currentTarget as HTMLElement).style.display = 'none';
                  }}
                />
              </div>
              <div className="absolute left-16 md:left-1/4 bottom-10 w-16 h-16 rounded-md overflow-hidden border-2 border-[#1f232e] shadow-lg bg-teal-600 flex items-center justify-center text-sm font-bold text-white">
                <img
                  src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&auto=format&fit=crop&q=80"
                  alt="User 2"
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    (e.currentTarget as HTMLElement).style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Slide 2 */}
        <div className="hero-slide w-1/3 flex-shrink-0 flex flex-col md:flex-row items-center justify-between !p-8 md:!p-12 md:!px-16 relative min-h-[350px]">
          <div className="w-full md:w-1/2 z-10 text-white">
            <h1 className="text-3xl md:text-5xl font-bold mb-4 tracking-tight leading-tight !text-white">
              Giao dịch 24/7,<br />
              Kiểm soát rủi ro
            </h1>
            <p className="text-gray-300 text-sm md:text-base mb-8 max-w-md leading-relaxed">
              Hệ thống tự động sao chép các lệnh giao dịch ngay cả khi bạn đang ngủ. Đặt mức cắt lỗ (Stop-Loss) cá nhân để bảo vệ nguồn vốn trong khi tận hưởng lợi nhuận.
            </p>
            <button className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-lg transition-colors">
              Tìm hiểu thêm
            </button>
          </div>
          <div className="w-full md:w-1/2 flex justify-center mt-6 md:mt-0 relative z-10 h-full items-center text-center">
            <div className="bg-[#292e3a] p-8 rounded-2xl border border-gray-700 shadow-2xl max-w-xs w-full">
              <div className="text-gray-400 mb-2">Bảo vệ vốn CopyTrader</div>
              <div className="text-4xl font-bold text-white mb-4">Mức Cắt Lỗ</div>
              <div className="text-red-400 font-bold text-2xl">-20%</div>
            </div>
          </div>
        </div>

        {/* Slide 3 */}
        <div className="hero-slide w-1/3 flex-shrink-0 flex flex-col md:flex-row items-center justify-between !p-8 md:!p-12 md:!px-16 relative min-h-[350px]">
          <div className="w-full md:w-1/2 z-10 text-white">
            <h1 className="text-3xl md:text-5xl font-bold mb-4 tracking-tight leading-tight !text-white">
              Cộng đồng Giao dịch<br />
              Lớn nhất Toàn cầu
            </h1>
            <p className="text-gray-300 text-sm md:text-base mb-8 max-w-md leading-relaxed">
              Khám phá các chiến lược từ Forex, Crypto, Cổ phiếu cho đến Hàng hóa. Trò chuyện, học hỏi và sao chép từ hàng triệu nhà giao dịch.
            </p>
            <button className="bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-6 rounded-lg transition-colors">
              Tham gia ngay
            </button>
          </div>
          <div className="w-full md:w-1/2 flex justify-center mt-6 md:mt-0 relative z-10 h-full items-center text-center">
            <div className="bg-[#292e3a] p-6 rounded-2xl border border-gray-700 shadow-2xl max-w-xs w-full flex flex-col items-center">
              <div className="flex -space-x-2 mb-4">
                <div className="w-10 h-10 rounded-full border-2 border-[#1f232e] bg-indigo-600 flex items-center justify-center font-bold text-xs text-white">M</div>
                <div className="w-10 h-10 rounded-full border-2 border-[#1f232e] bg-teal-600 flex items-center justify-center font-bold text-xs text-white">S</div>
                <div className="w-10 h-10 rounded-full border-2 border-[#1f232e] bg-amber-600 flex items-center justify-center font-bold text-xs text-white">A</div>
                <div className="w-10 h-10 rounded-full border-2 border-[#1f232e] bg-blue-600 flex items-center justify-center font-bold text-xs text-white">+5k</div>
              </div>
              <div className="text-white font-semibold text-lg mb-1">Hơn 50,000+ Trader</div>
              <div className="text-gray-400 text-xs">Đang chia sẻ và sao chép lệnh mỗi ngày</div>
            </div>
          </div>
        </div>
      </div>

      {/* Prev / Next Arrows */}
      <button
        onClick={() => moveSlide(-1)}
        className="absolute left-4 top-1/2 -translate-y-1/2 w-8 h-8 !rounded-full bg-black/40 hover:bg-black/60 flex items-center justify-center text-white border border-gray-600 z-30 transition-colors"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <button
        onClick={() => moveSlide(1)}
        className="absolute right-4 top-1/2 -translate-y-1/2 w-8 h-8 !rounded-full bg-black/40 hover:bg-black/60 flex items-center justify-center text-white border border-gray-600 z-30 transition-colors"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
      </button>

      {/* Dots Indicator */}
      <div className="absolute bottom-6 left-8 md:left-12 flex space-x-1.5 z-30">
        {[0, 1, 2].map((idx) => (
          <span
            key={idx}
            onClick={() => setSlideIndex(idx)}
            className={`inline-block h-1.5 rounded-full cursor-pointer transition-all duration-300 ${
              slideIndex === idx ? 'bg-green-500 w-4 rounded' : 'bg-gray-600 w-1.5'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroSlider;
